(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7bbe"];
var parcelRegister = parcelRequire.register;
parcelRegister("juUMX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $404c2e45504b5e2e$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");

var $dTCkE = parcelRequire("dTCkE");

var $gAKOc = parcelRequire("gAKOc");

var $l8eky = parcelRequire("l8eky");

var $cUbQm = parcelRequire("cUbQm");

var $f4XOk = parcelRequire("f4XOk");

const $404c2e45504b5e2e$var$ConsentHandler = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dTCkE))).lazy(()=>(parcelRequire("hMCpp")));

const $404c2e45504b5e2e$var$ConsentModal = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dTCkE))).lazy(()=>(parcelRequire("6v11L")));
const $404c2e45504b5e2e$var$Consent = ({ isEditPage: isEditPage, isCompleteProfilePage: isCompleteProfilePage })=>{
    const modalIsDismissed = (0, $l8eky.getSessionFlagWithExpiry)((0, $cUbQm.ConsentEnums).DismissedKey);
    if (modalIsDismissed && !isEditPage) return null;
    const { user: user, sessionId: sessionId } = (0, $dTCkE.useContext)((0, $gAKOc.MyPagesContext));
    if (!sessionId) return null; // Make sure user is logged in
    const [vitecSsn, setVitecSsn] = (0, $dTCkE.useState)(null);
    (0, $dTCkE.useEffect)(()=>{
        setVitecSsn(user?.vitecPerson?.socialSecurityNumber);
    }, [
        user
    ]);
    // Get potential consent and consentAnswers
    const { consent: consent, consentAnswers: consentAnswers, refetch: refetch } = (0, $f4XOk.default)(sessionId);
    return sessionId && vitecSsn ? /*#__PURE__*/ (0, $a9eYm.jsxs)((0, $a9eYm.Fragment), {
        children: [
            !isEditPage && !isCompleteProfilePage && consent && /*#__PURE__*/ (0, $a9eYm.jsx)($404c2e45504b5e2e$var$ConsentModal, {
                consent: consent,
                ssn: vitecSsn,
                modalIsDissmissed: modalIsDismissed,
                sessionId: sessionId
            }),
            isEditPage && /*#__PURE__*/ (0, $a9eYm.jsx)($404c2e45504b5e2e$var$ConsentHandler, {
                consent: consent,
                consentAnswers: consentAnswers,
                ssn: vitecSsn,
                refetch: refetch,
                sessionId: sessionId
            })
        ]
    }) : null;
};
var $404c2e45504b5e2e$export$2e2bcd8739ae039 = $404c2e45504b5e2e$var$Consent;

});
parcelRegister("f4XOk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e504724dfbdf18a2$export$2e2bcd8739ae039; });

var $dTCkE = parcelRequire("dTCkE");

var $1HGFx = parcelRequire("1HGFx");
// Test data to pass in place of resp values
//  below for light mockup testing
//===========================================
const $e504724dfbdf18a2$var$testConsent = {
    text: "##### (DUMMY DATA CONSENT) Dela mina uppgifter mellan L\xe4nsf\xf6rs\xe4kringar fastighetsf\xf6rmedling och \xf6vriga bolag inom LF-gruppen\n**Jag vill ha m\xf6jligheten att f\xe5 b\xe4ttre anpassade erbjudanden och rabatter, och samtycker d\xe4rf\xf6r till att mina uppgifter delas mellan L\xe4nsf\xf6rs\xe4kringar Fastighetsf\xf6rmedling och \xf6vriga bolag i LF-gruppen.**\n\nSyftet med att dela dina uppgifter mellan bolagen \xe4r att kunna ge dig paketerbjudanden, personliga rabatter och r\xe5dgivning anpassad efter dina behov. Om du ger samtycke delas information om till exempel\n- dina avtalsengagemang hos LF\n- k\xf6p och f\xf6rs\xe4ljning av bostad (ej l\xe5nel\xf6ftesbelopp)\n- ditt deltagande i budgivningar (inte budgivningsniv\xe5)\n- vilka sidor du visat intresse f\xf6r p\xe5 lansforsakringar.se och lansfast.se.\n\nDu kan n\xe4r som helst \xe5terkalla ditt samtycke via dina inloggade kanaler p\xe5 [lansforsakringar.se](https://www.lansforsakringar.se) eller [lansfast.se](https://www.lansfast.se). L\xe4s mer om [LF:s behandling av personuppgifter](https://www.lansforsakringar.se) och [Fastighetsf\xf6rmedlingens integritetspolicy](https://www.lansfast.se).",
    consentType: "LFLFFInformationsharing",
    consentVersion: {
        major: 9,
        minor: 0,
        patch: 0
    }
};
const $e504724dfbdf18a2$var$testConsentAnswers = [
    {
        status: "Declined",
        text: "##### (DUMMY DATA ANSWER) Dela mina uppgifter mellan L\xe4nsf\xf6rs\xe4kringar fastighetsf\xf6rmedling och \xf6vriga bolag inom LF-gruppen\n**Jag vill ha m\xf6jligheten att f\xe5 b\xe4ttre anpassade erbjudanden och rabatter, och samtycker d\xe4rf\xf6r till att mina uppgifter delas mellan L\xe4nsf\xf6rs\xe4kringar Fastighetsf\xf6rmedling och \xf6vriga bolag i LF-gruppen.**\n\nSyftet med att dela dina uppgifter mellan bolagen \xe4r att kunna ge dig paketerbjudanden, personliga rabatter och r\xe5dgivning anpassad efter dina behov. Om du ger samtycke delas information om till exempel\n- dina avtalsengagemang hos LF\n- k\xf6p och f\xf6rs\xe4ljning av bostad (ej l\xe5nel\xf6ftesbelopp)\n- ditt deltagande i budgivningar (inte budgivningsniv\xe5)\n- vilka sidor du visat intresse f\xf6r p\xe5 lansforsakringar.se och lansfast.se.\n\nDu kan n\xe4r som helst \xe5terkalla ditt samtycke via dina inloggade kanaler p\xe5 [lansforsakringar.se](https://www.lansforsakringar.se) eller [lansfast.se](https://www.lansfast.se). L\xe4s mer om [LF:s behandling av personuppgifter](https://www.lansforsakringar.se) och [Fastighetsf\xf6rmedlingens integritetspolicy](https://www.lansfast.se).",
        consentType: "LFLFFInformationsharing",
        uuid: "test-uuid-1",
        consentVersion: {
            major: 1,
            minor: 2,
            patch: 0
        }
    },
    {
        status: "Approved",
        text: "##### (DUMMY DATA ANSWER) Dela mina uppgifter mellan L\xe4nsf\xf6rs\xe4kringar fastighetsf\xf6rmedling och \xf6vriga bolag inom LF-gruppen\n**Jag vill ha m\xf6jligheten att f\xe5 b\xe4ttre anpassade erbjudanden och rabatter, och samtycker d\xe4rf\xf6r till att mina uppgifter delas mellan L\xe4nsf\xf6rs\xe4kringar Fastighetsf\xf6rmedling och \xf6vriga bolag i LF-gruppen.**\n\nSyftet med att dela dina uppgifter mellan bolagen \xe4r att kunna ge dig paketerbjudanden, personliga rabatter och r\xe5dgivning anpassad efter dina behov. Om du ger samtycke delas information om till exempel\n- dina avtalsengagemang hos LF\n- k\xf6p och f\xf6rs\xe4ljning av bostad (ej l\xe5nel\xf6ftesbelopp)\n- ditt deltagande i budgivningar (inte budgivningsniv\xe5)\n- vilka sidor du visat intresse f\xf6r p\xe5 lansforsakringar.se och lansfast.se.\n\nDu kan n\xe4r som helst \xe5terkalla ditt samtycke via dina inloggade kanaler p\xe5 [lansforsakringar.se](https://www.lansforsakringar.se) eller [lansfast.se](https://www.lansfast.se). L\xe4s mer om [LF:s behandling av personuppgifter](https://www.lansforsakringar.se) och [Fastighetsf\xf6rmedlingens integritetspolicy](https://www.lansfast.se).",
        consentType: "LFLFFInformationsharing",
        uuid: "test-uuid-2",
        consentVersion: {
            major: 1,
            minor: 0,
            patch: 0
        }
    }
];
//=========================================
const $e504724dfbdf18a2$var$useConsent = (sessiondId)=>{
    const [consent, setConsent] = (0, $dTCkE.useState)(null);
    const [consentAnswers, setConsentAnswers] = (0, $dTCkE.useState)(null);
    const isEmptyObject = (obj)=>Object.values(obj).every((value)=>value === null || value === undefined);
    const fetchConsentsAndAnswers = (0, $dTCkE.useCallback)(async ()=>{
        if (!sessiondId) return;
        // Consents (new consents)
        const consentResp = await (0, $1HGFx.ConsentService).consentGetConsents(sessiondId);
        // Consent Answers (prior consents)
        const consentAnswersResp = await (0, $1HGFx.ConsentService).consentGetConsentAnswer(sessiondId);
        // Update CONSENT state
        if (consentResp && !isEmptyObject(consentResp)) setConsent(consentResp);
        else setConsent(null);
        // Update CONSENT ANSWERS state
        if (consentAnswersResp && consentAnswersResp.length > 0) setConsentAnswers(consentAnswersResp);
        else setConsentAnswers(null);
        return;
    }, [
        sessiondId
    ]);
    (0, $dTCkE.useEffect)(()=>{
        if (sessiondId) fetchConsentsAndAnswers();
    }, [
        sessiondId,
        fetchConsentsAndAnswers
    ]);
    return {
        consent: consent,
        consentAnswers: consentAnswers,
        refetch: fetchConsentsAndAnswers
    };
};
var $e504724dfbdf18a2$export$2e2bcd8739ae039 = $e504724dfbdf18a2$var$useConsent;

});

parcelRegister("hMCpp", function(module, exports) {


module.exports = (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("8SJFM")).then(()=>parcelRequire("6rPMX"));

});

parcelRegister("6v11L", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("cgaO2")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("dirks"))
]).then(()=>parcelRequire("8h2ta"));

});


})();
//# sourceMappingURL=Consent.82869d09.js.map
